import { MATERIALS } from "../sim/materials";
import { registerSprite } from "./registry";

const FRAME_DARK_DEFAULT = "#15161a";
const FRAME_DEFAULT = "#2a2c34";

function chunkSvg(p: {
  veinDark: string; vein: string;
  frameDark?: string; frame?: string;
}): string {
  const fd = p.frameDark ?? FRAME_DARK_DEFAULT;
  const f = p.frame ?? FRAME_DEFAULT;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" shape-rendering="crispEdges">
    <rect width="8" height="8" fill="${fd}"/>
    <rect x="1" y="1" width="6" height="6" fill="${f}"/>
    <rect x="2" y="2" width="2" height="2" fill="${p.veinDark}"/>
    <rect x="4" y="4" width="2" height="2" fill="${p.veinDark}"/>
    <rect x="3" y="3" width="1" height="1" fill="${p.vein}"/>
    <rect x="5" y="5" width="1" height="1" fill="${p.vein}"/>
  </svg>`;
}

for (const m of MATERIALS) {
  registerSprite(m.chunkId, { width: 8, height: 8, svg: chunkSvg(m.chunkPalette) });
}